// extracted by mini-css-extract-plugin
export default {"Label":"Label-module__Label--LDLcv","Icon":"Label-module__Icon--bu0rz"};